import { Stage } from "./core/stage";

export function createStage(params) {
    return new Stage(params);
}
//# sourceMappingURL=create.js.map